import { Transport, TransportRequest, TransportResponse } from "../transport/Transport"
import { EventDto, toPayload } from "./dto"
import { ApiCallMetrics } from "../metrics/monitoring/ApiCallMetrics"

export abstract class EventTransport {
  protected constructor(private readonly transport: Transport) {}

  send(events: EventDto[]): Promise<TransportResponse> {
    const request = this.createRequest(events)
    return this.execute(request)
  }

  protected abstract createRequest(events: EventDto[]): TransportRequest

  private execute(request: TransportRequest): Promise<TransportResponse> {
    return ApiCallMetrics.record("post.events", () => this.transport.send(request))
  }
}

export class BrowserEventTransport extends EventTransport {
  constructor(private readonly url: string, transport: Transport) {
    super(transport)
  }

  protected createRequest(events: EventDto[]): TransportRequest {
    const payload = toPayload(events)
    return TransportRequest.builder()
      .url(this.url)
      .method("POST")
      .addHeader("Content-Type", "text/plain;charset=UTF-8") // text/plain body to avoid CORS preflight
      .body(JSON.stringify(payload))
      .build()
  }
}

export class NodeEventTransport extends EventTransport {
  constructor(private readonly url: string, transport: Transport) {
    super(transport)
  }

  protected createRequest(events: EventDto[]): TransportRequest {
    const payload = toPayload(events)
    return TransportRequest.builder()
      .url(this.url)
      .method("POST")
      .addHeader("Content-Type", "application/json")
      .body(JSON.stringify(payload))
      .build()
  }
}
